var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4H8V3C8 2.44772 8.44772 2 9 2H11C11.5523 2 12 2.44772 12 3V4H15C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6H5Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09914 8.09054C5.04591 7.50492 5.50701 7 6.09504 7H13.905C14.493 7 14.9541 7.50492 14.9009 8.09054L14.1654 16.1811C14.0717 17.2112 13.208 18 12.1736 18H7.82643C6.79203 18 5.9283 17.2112 5.83465 16.1811L5.09914 8.09054Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.32640eea12668419b88ed091edad2fd7.svg";
export { ForwardRef as ReactComponent };